import { parseEnumApiResponse } from '@app/helpers/memberships/formattedFields'
import { createEnumApi } from '../../partials/enumApi'

const title = createEnumApi(
    'bt_get_titles',
    {
        onDataReceived: data => parseEnumApiResponse(data.titles)
    }
)

export default title